// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const getSucursalesControlTiemposService = async (param: number) => {
  try {
    return await http.get<any>(`/v1/customer/search/${param}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('tonkaaaaaaaaaaaaaaaaaa getAllTipoNovedadService ', error);
  }
};

export const getEmployeesInShiftService = async () => {
  try {
    return await http.get<any>(`/v1/time-control/employees-in-shift`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployeesInShiftService ', error);
  }
};

export const outEmployeesInShiftService = async (employeeId: string) => {
  try {
    return await http.patch<any>(`/v1/time-control/out-employees-in-shift/${employeeId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployeesInShiftService ', error);
  }
};

export const postAiChatService = async (prompt: string) => {
  try {
    return await http.postLogin<any>(`/v1/time-control/ai-chat`, { prompt });
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('postAiChatService ', error);
  }
};
